import '@accessible360/accessible-slick';

export const TestimonialSlider = (() => {
	'use strict';

	function init() {
		if (!$('body').hasClass('wp-admin')) {

			$('.testimonial-slider').slick({
				dots: true,
				arrows: false,
				centerMode: true,
				speed: 200,
				autoplay: false,
				autoplaySpeed: 0,
				slidesToShow: 1,
				slidesToScroll: 1,
				responsive: [
					{
						breakpoint: 768,
						settings: {
							dots: false
						}
					}


				  ]
			});
		}


	}
	return {
		init: init,
		name: 'testimonial-slider'
	};
})();
